import { spineDescriptors } from './spine-index.js';
import { baseDescriptors } from './base-index.js';
import { processingActivityDescriptor } from './processing-activity.js';
import { dataFlowDescriptor } from './data-flow.js';
import { thirdPartyDescriptor } from './third-party.js';
import { dataBreachDescriptor } from './data-breach.js';
import { threatDescriptor } from './threat.js';
import { measureDescriptor } from './measure.js';
import { assetDescriptor } from './asset.js';
import { policyDescriptor } from './policy.js';
import { acceptanceDescriptor } from './acceptance.js';
import { contentDescriptor } from './content.js';
import { auditDescriptor } from './audit.js';
import { workerGroupDescriptor } from './worker-group.js';
import { amlVerificationDescriptor } from './aml-verification.js';
/** coreBOS-backed descriptors (harvested). */
export const coreBOSDescriptors = [
    processingActivityDescriptor,
    dataFlowDescriptor,
    thirdPartyDescriptor,
    dataBreachDescriptor,
    threatDescriptor,
    measureDescriptor,
    assetDescriptor,
    policyDescriptor,
    acceptanceDescriptor,
    contentDescriptor,
    auditDescriptor,
    workerGroupDescriptor,
    amlVerificationDescriptor,
];
/** Everything the pack registers: harvested + contracts base (ADR-031) + kernel-native spines (hand-written). */
export const descriptors = [...coreBOSDescriptors, ...baseDescriptors, ...spineDescriptors];
